// src/components/chatPolicy/PolicyTester.jsx
// Selecciona un usuario remitente y uno destinatario; consulta la policy
// y muestra el veredicto + razón humana legible.
import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import UserTypeahead from './UserTypeahead';
import { testPolicy } from '../../services/chatPolicyApi';

export default function PolicyTester({ catalog }) {
    const [from, setFrom] = useState([]); // typeahead controla array; tomamos [0]
    const [to,   setTo]   = useState([]);
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);

    const run = async () => {
        const f = from[0]; const t = to[0];
        if (!f || !t) { toast.warn('Selecciona remitente y destinatario'); return; }
        setLoading(true);
        try {
            const r = await testPolicy(f._id, t._id);
            setResult(r);
        } catch (e) {
            toast.error(e.response?.data?.error || 'Error al probar');
        } finally { setLoading(false); }
    };

    return (
        <div style={{ background: 'var(--c-card)', border: '1px solid var(--c-border)', borderRadius: 12, padding: 16 }}>
            <h5 style={{ fontWeight: 700, marginBottom: 4 }}>Probar policy</h5>
            <p style={{ fontSize: 12, color: 'var(--c-text-4)', marginBottom: 12 }}>
                Verifica si una persona podría iniciar chat con otra según las reglas actuales.
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                <div>
                    <label style={{ fontSize: 12, fontWeight: 600 }}>Remitente</label>
                    <UserTypeahead
                        catalog={catalog}
                        value={from}
                        onChange={(v) => setFrom(v.slice(-1))}
                        placeholder="Buscar persona…"
                    />
                </div>
                <div>
                    <label style={{ fontSize: 12, fontWeight: 600 }}>Destinatario</label>
                    <UserTypeahead
                        catalog={catalog}
                        value={to}
                        onChange={(v) => setTo(v.slice(-1))}
                        placeholder="Buscar persona…"
                    />
                </div>
            </div>

            <Button size="sm" variant="primary" onClick={run} disabled={loading} style={{ borderRadius: 8 }}>
                {loading ? <Spinner size="sm" animation="border" /> : 'Probar'}
            </Button>

            {result && (
                <div style={{
                    marginTop: 14, padding: 12, borderRadius: 8,
                    background: result.allowed ? 'rgba(34,197,94,.1)' : 'rgba(239,68,68,.1)',
                    border: `1px solid ${result.allowed ? '#22c55e' : '#ef4444'}`,
                }}>
                    <div style={{ fontWeight: 700, color: result.allowed ? '#15803d' : '#b91c1c', marginBottom: 4 }}>
                        {result.allowed ? '✓ Permitido' : '✗ Denegado'}
                    </div>
                    <div style={{ fontSize: 13, marginBottom: 8 }}>{result.reason}</div>
                    <div style={{ fontSize: 11, color: 'var(--c-text-4)' }}>
                        <strong>{result.from?.name}</strong> ({result.from?.puesto || result.from?.role}{result.from?.unidad ? ` · ${result.from.unidad}` : ''})
                        <span style={{ margin: '0 6px' }}>→</span>
                        <strong>{result.to?.name}</strong> ({result.to?.puesto || result.to?.role}{result.to?.unidad ? ` · ${result.to.unidad}` : ''})
                    </div>
                </div>
            )}
        </div>
    );
}
